import "../styles/userFilters.scss";
import { Button } from "@mui/material";
import { MultivalueInput } from "../components";
import { useEffect, useState } from "react";
import React from "react";
import { getUserFilterSettings, saveUserFilterSettings } from "../components/api";

export const UserFilters = () => {
    const [savedSelectedCities, setSavedSelectedCities] = useState([]);
    const [savedSelectedMarks, setSavedSelectedMarks] = useState([]);
    const [savedSelectedPriceSegments, setSavedSelectedPriceSegments] = useState([]);

    const [citiesChanged, setCitiesChanged] = useState(false);
    const [selectedCities, setSelectedCities] = useState([]);

    const [marksChanged, setMarksChanged] = useState(false);
    const [selectedMarks, setSelectedMarks] = useState([]);

    const [priceSegmentsChanged, setPriceSegmentsChanged] = useState(false);
    const [selectedPriceSegments, setSelectedPriceSegments] = useState([]);

    const [marks, setMarks] = useState([]);
    const [cities, setCities] = useState([]);
    const [priceSegments, setPriceSegments] = useState([]);

    const [someValueWasChanged, setSomeValueWasChanged] = useState(false);

    const allElement = { id: 0, name: 'Все' };

    const [isInit, setIsInit] = useState(true);

    useEffect(() => {
        if (isInit) {
            getUserFilterSettings().then(userFilters => {
                let allCities = getCollectionWithSelectAllElement(userFilters.cities);
                let allMarks = getCollectionWithSelectAllElement(userFilters.marks);
                let allPriceSegments = getCollectionWithSelectAllElement(userFilters.priceSegments);

                setCities(allCities);
                setMarks(allMarks);
                setPriceSegments(allPriceSegments);

                const selectAllPredicate = () => true;

                let savedCities = userFilters.selectedCities && userFilters.selectedCities.some(selectAllPredicate)
                    ? allCities.filter(city => userFilters.selectedCities.some((selectedCityId) => selectedCityId == city.id))
                    : [allElement];

                let savedMarks = userFilters.selectedMarks && userFilters.selectedMarks.some(selectAllPredicate)
                    ? allMarks.filter(mark => userFilters.selectedMarks.some((selectedMarkId) => selectedMarkId == mark.id))
                    : [allElement];

                let savedPriceSegments = userFilters.selectedPriceSegments && userFilters.selectedPriceSegments.some(selectAllPredicate)
                    ? allPriceSegments.filter(segment => userFilters.selectedPriceSegments.some((selectedSegmentId) => selectedSegmentId == segment.id))
                    : [allElement];

                setSavedSelectedCities(savedCities);
                setSavedSelectedMarks(savedMarks);
                setSavedSelectedPriceSegments(savedPriceSegments);

                setSelectedCities(savedCities);
                setSelectedMarks(savedMarks);
                setSelectedPriceSegments(savedPriceSegments);
            });

            setIsInit(false);
        }
    }, []);

    useEffect(() => {
        setSomeValueWasChanged(citiesChanged || marksChanged || priceSegmentsChanged);
    }, [citiesChanged, marksChanged, priceSegmentsChanged])

    useEffect(() => {
        if (!someValueWasChanged) {
            setCitiesChanged(false);
            setMarksChanged(false);
            setPriceSegmentsChanged(false);
        }
    }, [someValueWasChanged]);

    const getCollectionWithSelectAllElement = (collection) => [allElement, ...collection];

    const collectionsIsEqual = (collection1, collection2) => {
        let isEqual = true;

        if (collection1.length === collection2.length) {
            for (let index1 in collection1) {
                let value1 = collection1.at(index1)
                for (let index2 in collection2) {
                    if (value1.id !== collection2.at(index2).id) {
                        isEqual = false;
                        break;
                    }
                }

                if (!isEqual)
                    break;
            }
        }
        else {
            isEqual = false;
        }

        return isEqual;
    }

    const setSelectedValues = (newValues, allValues, selectedValues, selectedValuesAccessor, savedValues, valuesWasChangedFlag, valuesWasChangedFlagAccessor) => {
        if (newValues.length === 0) {
            newValues = [allElement];
        }
        else {
            let allElementInNewValues = Array.from(newValues).find(item => item.id === 0);
            if (allElementInNewValues) {
                let hasAllElementInSelectedElements = selectedValues.some(item => item.id === 0);
                if (hasAllElementInSelectedElements) {
                    let applingValues = Array.from(newValues).find(item => item.id !== 0);
                    newValues = applingValues instanceof Array ? applingValues : [applingValues];
                }
                else {
                    newValues = [allElement];
                }
            }
        }

        if (collectionsIsEqual(newValues, selectedValues))
            return;

        if (collectionsIsEqual(newValues, savedValues)) {
            valuesWasChangedFlagAccessor(false);
            selectedValuesAccessor(savedValues);

            return;
        }

        if (!valuesWasChangedFlag)
            valuesWasChangedFlagAccessor(true);

        selectedValuesAccessor(newValues);
    }

    const onCitiesChanged = (value) => setSelectedValues(value, cities, selectedCities, setSelectedCities, savedSelectedCities, citiesChanged, setCitiesChanged);
    const onMarksChanged = (value) => setSelectedValues(value, marks, selectedMarks, setSelectedMarks, savedSelectedMarks, marksChanged, setMarksChanged);
    const onPriceSegmentsChanged = (value) => setSelectedValues(value, priceSegments, selectedPriceSegments, setSelectedPriceSegments, savedSelectedPriceSegments, priceSegmentsChanged, setPriceSegmentsChanged);

    const onSaveButtonClick = (value) => {
        setSomeValueWasChanged(false);

        const getElementsForSend = (collection) => collection.filter(element => element.id !== 0).map(element => element.id);

        saveUserFilterSettings(
            {
                cities: citiesChanged ? getElementsForSend(selectedCities) : null,
                marks: marksChanged ? getElementsForSend(selectedMarks) : null,
                priceSegments: priceSegmentsChanged ? getElementsForSend(selectedPriceSegments) : null
            }
        );

        setSavedSelectedCities(selectedCities);
        setSavedSelectedMarks(selectedMarks);
        setSavedSelectedPriceSegments(selectedPriceSegments);

        setSelectedCities(selectedCities);
        setSelectedMarks(selectedMarks);
        setSelectedPriceSegments(selectedPriceSegments);
    };

    const onReturnButtonClick = (value) => {
        if (citiesChanged) {
            setSelectedCities(savedSelectedCities);
            setCitiesChanged(false);
        }

        if (marksChanged) {
            setSelectedMarks(savedSelectedMarks);
            setMarksChanged(false);
        }

        if (selectedPriceSegments) {
            setSelectedPriceSegments(savedSelectedPriceSegments);
            setPriceSegmentsChanged(false);
        }
    }

    return (
        <div>
            <h1 className="page-header">Мои фильтры</h1>

            <MultivalueInput className="user-filters__input-element" title="Города выкупа" elements={cities} value={selectedCities} onChange={onCitiesChanged} />
            <MultivalueInput className="user-filters__input-element" title="Марки автомобилей" elements={marks} value={selectedMarks} onChange={onMarksChanged} />
            <MultivalueInput className="user-filters__input-element" title="Ценовые сегменты" elements={priceSegments} value={selectedPriceSegments} onChange={onPriceSegmentsChanged} />

            <div className="user-filters__buttons-container">
                <Button className="user-filters__button" variant="contained" disabled={!someValueWasChanged} onClick={onSaveButtonClick}>Сохранить</Button>
                <Button className="user-filters__button" variant="contained" disabled={!someValueWasChanged} onClick={onReturnButtonClick}>Вернуть</Button>
            </div>
        </div>
    )
}